import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PitBpmRestService} from "../../../../pit-shared/services/pit-bpm-rest.service";
import {DxControlPointInstance} from "../../../../pit-shared/domain/control-points/dx-control-point-instance";
import {DxGridOptions} from "../../../../dx-grid/domain/ui-options/dx-grid-options";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {FormGroup} from "@angular/forms";
import {DxControlPointChainGeneration} from "../../../../pit-shared/domain/control-points/dx-control-point-chain-generation";
import {switchMap} from "rxjs/operators";
import {DxAppError} from "../../../../dx-core/domain/error/dx-app-error";

@Component({
  selector: 'pit-control-points',
  templateUrl: './pit-control-points.component.html',
  styleUrls: ['./pit-control-points.component.css']
})
export class PitControlPointsComponent implements OnInit, OnChanges {

  @Input()
  anObject: {id: number, isModified?: boolean};

  @Input()
  anObjectTypeId: number;

  @Input()
  baseDate: Date;

  @Input()
  patterns: {id: number, name: string}[];

  formGroup: FormGroup = new FormGroup({});

  controlPoints: DxControlPointInstance[] = [];
  controlPointsOptions: DxGridOptions;

  isLoading = false;

  constructor(private configService: BdpkConfigService,
              private bpmService: PitBpmRestService) { }

  ngOnInit() {
    if (!this.anObject || !this.anObjectTypeId || !this.patterns) {
      throw new DxAppError('not all required inputs are presented');
    }
  }

  ngOnChanges(changes: SimpleChanges, force: boolean = false) {
    console.log('anObject', this.anObject);
    // init is here
    if (this.anObject.id && this.anObjectTypeId && !this.anObject.isModified) {

      this.isLoading = true;
      // this.configService.loadPitControlPointsGridOptions().pipe(
      //   switchMap(result => {
      //     this.controlPointsOptions = result;
      //     return this.bpmService.controlPointInstances(this.anObject.id, this.anObjectTypeId, null)
      //   }
      // )).subscribe(
      //     controlPoints => {
      //       this.isLoading = false;
      //       // post deserialize
      //       controlPoints.forEach(cpoint => {
      //         if (cpoint.pattern.prevId)
      //           cpoint.pattern.prevName = controlPoints.find(cp => cp.pattern.id === cpoint.pattern.prevId).pattern.name;
      //       });
      //       // apply
      //       this.controlPoints = controlPoints;
      //     },
      //     error => {
      //       this.isLoading = false;
      //     }
      // );
    }
  }

  onCreateButton(chainPatternId: number) {
    this.isLoading = true;
    this.bpmService.controlPointChainInstancesGeneration(new DxControlPointChainGeneration({
      baseDate: this.baseDate,
      businessObject: {
        id: this.anObject.id,
        typeId: this.anObjectTypeId
      },
      chainPatternId: chainPatternId
    })).subscribe(
      chainInstance => {
        this.isLoading = false;
        this.controlPoints = chainInstance.points;
      },
      error => {
        this.isLoading = false;
      }
    );
  }

  /** Подкраска строк в гриде с превышением лимитов */
  public rowHighlight = {
    "limit-warning": function (params) {
      const cpoint = params.data as DxControlPointInstance;
      return cpoint.plannedPassageDate < cpoint.actualPassageDate;
    }
  };

  regeneratePoints() {
    const chainId = this.controlPoints.reduce((prev, curr) => prev.chainInstanceId < curr.chainInstanceId ? prev : curr).chainInstanceId;
    this.isLoading = true;
    this.bpmService.controlPointChainInstancesRedistribution(chainId, this.baseDate).subscribe(
      chainInstance => {
        this.isLoading = false;
        this.controlPoints = chainInstance.points;
      },
      error => {
        this.isLoading = false;
      }
    );
  }
}
